import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { dataTableRender } from '../components/functions'
import api from '../components/api';
import ModalBarraLateral from '../modals/barraLateral'


const Biblioteca = () => {

    const history = useHistory()

    var [barraLateral_id, setBarraLateral_id] = useState()
    var pagina_id = 'Biblioteca'

    var [resultado, setResultado] = useState()
    var [resultadoTemas, setResultadoTemas] = useState()
    var [conteudoBarraLateral, setConteudoBarraLateral] = useState()
    var [ordem, setOrdem] = useState("")


    async function carregaBarraLateral() {

        //console.log('!!')

        await api.get(`barraLateral/${pagina_id}`).then((result) => {

            //console.log(result.data)

            setConteudoBarraLateral(result.data.map((rs) =>

                <tr style={{ cursor: 'pointer'}} data-toggle="modal" data-target="#modalBarraLateral" onClick={() => setBarraLateral_id(rs.barraLateral_id)}>
                    <td>{rs.titulo}</td>
                    <td><center>{rs.topico}</center></td>
                    <td><center>{rs.dataAtualizacao}</center></td>
                    
                </tr>
            
            ))

            dataTableRender('tabelaBarraLateral')

            
        }).catch((err) => {

            console.log(err.response)

        })

    }


    function salvaOrdem(bibl_id, ordem) {


        if (bibl_id && ordem) {

            api.put(`biblOrdem/${bibl_id}/${ordem}`).then((result) => {

                //console.log(result.data)
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })
    

        }

        
    }

    

    const details_handler = (event, index) => {
        
        //const items = [...resultado];
        //items[index][event.target.name] = event.target.value;
        //console.log(event.target.value)
        //setOrdem(prevSearchTerm => ({...prevSearchTerm, [event.target.id]: event.target.value}))
        //setOrdem(event.target.value);
        salvaOrdem(event.target.id, event.target.value)
     }



     



    function carregaDados() {

        api.get('bibl').then((result) => {

            //console.log(result.data)
            setResultado(result.data.map((rs, index) => 


                    <tr key={index}>
                        <td style={{ cursor: 'pointer'}} onClick={() => history.push(`/Biblioteca/${rs.bibl_id}`)}>
                            {rs.tema_descri}
                        </td>
                        <td style={{ cursor: 'pointer'}} onClick={() => history.push(`/Biblioteca/${rs.bibl_id}`)}>
                            {rs.descricao}
                        </td>
                        <td style={{ cursor: 'pointer'}} onClick={() => history.push(`/Biblioteca/${rs.bibl_id}`)}>
                            {rs.titulo}
                        </td>
                        <td style={{ cursor: 'pointer'}} onClick={() => history.push(`/Biblioteca/${rs.bibl_id}`)}>
                            {rs.idioma_descri}
                        </td>
                        <td>
                            <input type="text" 
                            
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                                }
                            }}  
                            
                            disabled={ rs.oculto == true ? true : false } id={rs.bibl_id} defaultValue={rs.ordem} className="form-control" onChange={(e) => details_handler(e, index)} />
                        </td>
                        <td >
                            <center>
                            {rs.oculto == true ? 'Sim' : ''}
                            </center>
                        </td>
                    </tr>
               

                   
        ))

            dataTableRender('tabelaBiblioteca')


        }).catch((err) => {

            console.log(err.response)

        })        

    }



    function carregaTemas() {

        api.get('temas').then((result) => {

            setResultadoTemas(result.data.map((rs) =>
            
                <tr>
                    <td>
                        {rs.tema_descri}
                    </td>
                </tr>
            
            ))

        dataTableRender('tabelaTemas')

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        carregaDados()
        

    }, [])

    return (

        <div>

                
            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-pin'></i>
                </div>
                <div class='header-title'>
                    <h1>Biblioteca</h1>
                    <small>Administração</small>
                    
                </div>
            </div>



            <div className="row">

                <div class="col-md-12">

                    
                    <button type="button" onClick={() => history.push('/Biblioteca/Nova')} class="btn btn-info" >+ Novo registro</button>&nbsp;
                    
                    <br/><br/>

                </div>

                
                <ul className="nav nav-tabs">
                    <li className="active"><a href="#tab1" data-toggle="tab">Biblioteca</a></li>
                    <li ><a href="#tab3" data-toggle="tab" onClick={() => carregaBarraLateral()}>Barra Lateral</a></li>
                    <li ><a href="#tab2" data-toggle="tab" onClick={() => carregaTemas()}>Temas</a></li>
                    
                    
                </ul>
                        
                <div class="tab-content">
                    <div class="tab-pane fade in active" id="tab1">
                        <div class="panel-body">


                        
                                    
                            <div className="table-responsive">
                                <table id="tabelaBiblioteca" className="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Tema</th>
                                            <th>Tipo</th>
                                            <th>Título</th>
                                            <th>Idioma</th>
                                            <th>Ordem</th>
                                            <th>Oculto</th>
                                                                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultado}
                                    </tbody>
                                    
                                </table>
                            </div>
                                
                        


                        </div>
                    </div>
                    <div className="tab-pane fade in" id="tab2">
                        <div className="panel-body">

                        <div className="table-responsive">
                                <table id="tabelaTemas" className="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                                                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultadoTemas}
                                    </tbody>
                                    
                                </table>
                            </div>



                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tab3">
                        <div className="panel-body">

                            <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalBarraLateral" onClick={() => setBarraLateral_id()}>+ Novo</button>
                            <br/><br/><br/>
                                
                                <div className="table-responsive">
                                    <table id="tabelaBarraLateral" className="table table-bordered table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Título</th>
                                                <th><center>Tópico</center></th>
                                                <th><center>Incluso em</center></th>
                                                
                                                
                                                
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {conteudoBarraLateral}
                                            
                                        </tbody>
                                        
                                    </table>
                                
                                </div>



                        </div>

                    </div>

                    
                </div>


                
            </div>


            <ModalBarraLateral barraLateral_id={barraLateral_id} carregaBarra={carregaBarraLateral} pagina_id={pagina_id} />


        </div>

    )

}


export default Biblioteca